export default __webpack_public_path__ + "dist/media/Recall.91415c5a.svg";